import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../../core/services/notification';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed top-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
      @for (toast of notificationService.toasts(); track toast.id) {
        <div 
          class="min-w-[300px] p-4 rounded-lg shadow-lg text-white pointer-events-auto transition-transform"
          [ngClass]="{
            'bg-green-600': toast.type === 'success',
            'bg-red-600': toast.type === 'error',
            'bg-blue-600': toast.type === 'info'
          }"
        >
          <div class="flex justify-between items-center">
            <span>{{ toast.message }}</span>
            <button (click)="notificationService.remove(toast.id)" class="ml-4 hover:text-gray-200 font-bold" aria-label="Chiudi notifica">×</button>
          </div>
        </div>
      }
    </div>
  `
})
export class ToastComponent {
  notificationService = inject(NotificationService);
}
